import { useEffect, useState } from "react";
import BackToTopIcon from "../../../setup/custom_icons/BackToTopIcon";

function BackToTopButton() {
    const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
        checkScrollTop();

        window.addEventListener("scroll", checkScrollTop);
        return function cleanup() {
            window.removeEventListener("scroll", checkScrollTop);
        };
    }, []);

    const checkScrollTop = () => {
        if (!showScroll && window.scrollY > 400) {
            setShowScroll(true);
        } else if ((showScroll && window.scrollY <= 400) || window.scrollY === 0) {
            setShowScroll(false);
        }
    };

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };


    return (
        <span className="back-to-top-button" onClick={scrollTop} style={{ display: showScroll && window.scrollY > 0 ? 'flex' : 'none' }}>
            <BackToTopIcon />
        </span>
    );
}

export default BackToTopButton;